import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

import { logos } from './logos.ts'

export const meta: MetaFunction = () => [
	{ title: 'Our Insurance Company Relationships' },
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="text-4xl font-black">Companies</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Over the years we have developed relationships with respected insurance
				companies in order to offer insurance options to families, small
				businesses, nonprofits, and public entities.
			</p>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Click the logo of an insurance company to see more details and see
				options for getting help with billing, claims, and policy service.
			</p>

			<div className="bg-white">
				<div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
					<div className="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
						{logos.map(insurer => (
							<div
								key={insurer.name}
								className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1"
							>
								<Link to={`${insurer.pagePath}`} prefetch="intent">
									<img className="w-36" src={insurer.src} alt={insurer.name} />
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
		</main>
	)
}
